import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  CreatePartePayload,
  ParteListItem,
  UpdatePartePayload,
} from '@/types/processos/parteStoreTypes';

import { partesService } from './services';

export const listarPartes = createAsyncThunk<ParteListItem[], string>(
  'partes/listar',
  async (processoId, { rejectWithValue }) => {
    try {
      return await partesService.listar(processoId);
    } catch (error) {
      return rejectWithValue((error as Error).message) as unknown as ParteListItem[];
    }
  },
);

export const criarParte = createAsyncThunk<ParteListItem, CreatePartePayload>(
  'partes/criar',
  async (payload, { rejectWithValue }) => {
    try {
      return await partesService.criar(payload);
    } catch (error) {
      return rejectWithValue((error as Error).message) as unknown as ParteListItem;
    }
  },
);

export const atualizarParte = createAsyncThunk<ParteListItem, UpdatePartePayload>(
  'partes/atualizar',
  async ({ id, dados }, { rejectWithValue }) => {
    try {
      return await partesService.atualizar(id, dados);
    } catch (error) {
      return rejectWithValue((error as Error).message) as unknown as ParteListItem;
    }
  },
);

export const removerParte = createAsyncThunk<string, string>(
  'partes/remover',
  async (id, { rejectWithValue }) => {
    try {
      await partesService.remover(id);
      return id;
    } catch (error) {
      return rejectWithValue((error as Error).message) as unknown as string;
    }
  },
);

export const atualizarOrdemParte = createAsyncThunk<ParteListItem, { id: string; ordem: number }>(
  'partes/atualizarOrdem',
  async ({ id, ordem }, { rejectWithValue }) => {
    try {
      return await partesService.patchOrdem(id, ordem);
    } catch (error) {
      return rejectWithValue((error as Error).message) as unknown as ParteListItem;
    }
  },
);
